import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { MyObservation } from 'libs/end-to-end/src/my-observation';

export const getMetricByColumnHeaderValueFromObservation = ({
  columnHeaderValue,
  myObservation,
}: {
  columnHeaderValue: string;
  myObservation: MyObservation | null;
}) => {
  return myObservation?.focusAreas
    .flatMap((f) => f.metrics)
    .find((m) => m.columnHeaderValue === columnHeaderValue);
};

export const getMetricDisplayNameFromObservation = ({
  metricName,
  focusArea,
  myObservation,
}: {
  metricName: string;
  focusArea: FocusArea;
  myObservation: MyObservation | null;
}): string | null => {
  const focusAreaDefinition = myObservation?.focusAreas.find(
    (f) => f.focusArea === focusArea,
  );

  if (!focusAreaDefinition) {
    return null;
  }

  const metricDefinition = focusAreaDefinition.metrics.find(
    (m) => m.columnHeaderValue === metricName,
  );

  return metricDefinition?.displayName ?? null;
};

export const getMetricByNameFromObservation = ({
  metricName,
  focusArea,
  myObservation,
}: {
  metricName: string;
  focusArea: FocusArea;
  myObservation: MyObservation | null;
}) => {
  const focusAreaDefinition = myObservation?.focusAreas.find(
    (f) => f.focusArea === focusArea,
  );

  if (!focusAreaDefinition) {
    return undefined;
  }

  const metricDefinition = focusAreaDefinition.metrics.find(
    (m) => m.columnHeaderValue === metricName,
  );

  return metricDefinition;
};

export const getMetricsByFocusAreaFromObservation = ({
  focusArea,
  myObservation,
}: {
  focusArea: FocusArea;
  myObservation: MyObservation | null;
}) => {
  const focusAreaDefinition = myObservation?.focusAreas.find(
    (f) => f.focusArea === focusArea,
  );

  return focusAreaDefinition?.metrics ?? [];
};
